import { Response } from '@marketplace-web/shared/api-client'

import { GetSellerFiltersResp } from '../types/seller-filters'

export const transformGetSellerFiltersResponse = (response: Response<GetSellerFiltersResp>) =>
  response.filters.reduce((obj, filter) => ({ ...obj, [filter.name]: filter.count }), {})
